var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportClaimIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.67 18.47c.638 1.124-.162 2.53-1.435 2.53H3.66c-1.276 0-2.073-1.408-1.436-2.53L10.51 3.842a1.644 1.644 0 012.872 0l8.288 14.626zm-.955.561L12.426 4.406a.548.548 0 00-.957 0l-8.29 14.625c-.212.376.055.844.479.844h16.579c.426 0 .69-.47.479-.844zm-8.768-2.953a.976.976 0 00-.967.985c0 .543.433.984.967.984.535 0 .968-.44.968-.985a.976.976 0 00-.968-.984zm-.396-7.453h.793c.236 0 .424.2.414.44l-.241 5.906a.418.418 0 01-.415.404h-.31a.418.418 0 01-.414-.404l-.242-5.907a.419.419 0 01.415-.439zm.396 7.453a.976.976 0 00-.967.985c0 .543.433.984.967.984.535 0 .968-.44.968-.985a.976.976 0 00-.968-.984z",
    fill: "var(--color-secondary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportClaimIcon);
export default __webpack_public_path__ + "static/media/report-claim-icon.5db8b310d97767b48bd82dd4654d7451.svg";
export { ForwardRef as ReactComponent };